import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import RouterContext from "../../context/RouterContext";
import { styled } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import InfoIcon from '@mui/icons-material/Info';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import "../../App.css";
import axios from 'axios';
import {Box} from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import {ThreeDots} from 'react-loader-spinner';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import {updateSeduta} from "./Utils";
import {properties} from "../../utils/properties";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import IconButton from '@mui/material/IconButton';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Modal from '@mui/material/Modal';
import PreviewIcon from '@mui/icons-material/Preview';
import AddIcon from '@mui/icons-material/Add';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { encode } from 'js-base64';
//import { Editor } from '@tinymce/tinymce-react';
import SweetAlert from "react-bootstrap-sweetalert";
import {Stack} from "@mui/material";
import 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import { Editor } from '@tinymce/tinymce-react';
//import { ConstructionOutlined, ElectricScooterRounded, FolderZip } from "@mui/icons-material";
import LockPersonIcon from '@mui/icons-material/LockPerson';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import HttpsIcon from '@mui/icons-material/Https';
import NoEncryptionGmailerrorredIcon from '@mui/icons-material/NoEncryptionGmailerrorred';
import Chip from '@mui/material/Chip';
import Badge from '@mui/material/Badge';
import DoneIcon from '@mui/icons-material/Done';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import EventIcon from "@mui/icons-material/Event";



export default function Card() {
    
    let {dataSeduta, faseSeduta, idScheda } = useParams();    
    const [alert, setAlert] = React.useState(null);
    const [loading, setLoading]= React.useState(true);  
    const [score, setScore] = useState([]);
    const [homeData, setHomeData] = useState([]);    
    const [relazioneData, setRelazioneData] = useState([]);    
    const navigate = useNavigate();
    const { pageRouter, setPageRouter } = useContext(RouterContext);         
    
    const [open, setOpen] = useState(false);
    const [openedLabel, setOpenedLabel]= useState(null);
    const [openII, setOpenII] = useState(false);
    const [editorContent, setEditorContent] = useState('');
    const [itemContent, setItemContent] = useState('');
    const [commentContent, setCommentContent] = useState('');

    //
    const [praticaBloccataOriginalField, setPraticaBloccataOriginalField] = useState('');
    //const [praticaUltimaModificaOriginalField, setPraticaUltimaModificaOriginalField] = useState('');
    //const [praticaModificataDaOriginalField, setPraticaModificataDaOriginalField] = useState('');
    const [praticaBloccata, setPraticaBloccata] = useState(false);
    const [praticaUltimaModifica, setPraticaUltimaModifica] = useState('');
    const [praticaModificataDa, setPraticaModificataDa] = useState('');
    
    const [sedutePrecedenti, setSedutePrecedenti] = useState('');
    //

    const hiddenFileUpload2 = React.useRef(null);

    /*function normalizeQuill(html) {
        if (!html) return '';
        return html.replace(/(<p><br><\/p>)+$/g, '').trim();
    }*/
/*    const sanitizeImporto = (v) => v
        .replace(/[^0-9,]/g, '')     // solo numeri e virgola
        .replace(/(,.*),/g, '$1');
*/

const formatDate = (dateStr) => {
    if (!dateStr || dateStr.length !== 8) return dateStr;
    return `${dateStr.substring(0, 2)}/${dateStr.substring(2, 4)}/${dateStr.substring(4)}`;
  };

const handleChipClick= (row) => {  
    console.log("CHIP",row);
    //fascicoli/10122024/proposteintervento/schede/125742
    //navigate()

    var url=properties.productionUrl+"/fascicoli/"+row+"/proposteintervento/schede/"+idScheda;        
    //var url="https://fascicolo.compagniadisanpaolo.it/fascicoli/"+row+"/proposteintervento/schede/"+idScheda;        
    console.log("URL",url);
    window.open(url+"?dt="+(new Date()).getTime());        
}


const handleChipClickWithMamma= (row, mamma) => {  
    console.log("CHIP",row);
    //fascicoli/10122024/proposteintervento/schede/125742
    //navigate()
    var url=properties.productionUrl+"/fascicoli/"+row+"/proposteintervento/schede/"+mamma;        
    //var url="https://fascicolo.compagniadisanpaolo.it/fascicoli/"+row+"/proposteintervento/schede/"+mamma;        
    console.log("URL",url);
    window.open(url+"?dt="+(new Date()).getTime());        
}

const handleTdClick= (row) => {  
    console.log("TD",row);
    //var url=properties.productionUrl+"/fileManager/files/premesse/"+idDossier+"/"+name;        
    var url=properties.productionUrl+"/fileManager/files/generated/"+dataSeduta+"/"+faseSeduta+"/allegati/"+idScheda+"/"+row.value;        
    console.log("URL",url);
    window.open(url+"?dt="+(new Date()).getTime());        
}

const showAlert = (value) => {  
    setAlert(
      <SweetAlert
      error
      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
      title={value}
      text="ciao"      
      onConfirm={() => { setAlert(null) }}
      //onCancel={() => { navigate(-1) }}
      confirmBtnCssClass="custom-btn custom-btn-success" 
      cancelBtnCssClass="custom-btn custom-btn-cancel"      
      confirmBtnText="Indietro"      
    >
    </SweetAlert>
    );
};

const toNumberIT = (value) => {
    if (value == null || value === "") return 0;
  
    let v = value;
  
    if (typeof v === "string" && v.includes(",")) {
      v = v.replaceAll(".", "").replace(",", ".");
    }
  
    const n = Number(v);
    return isNaN(n) ? 0 : n;
  };

  /* const sanitizeImporto = (value) => {
    if (!value) return "";      
    let v = value.replace(/[^0-9,]/g, "");      
    const parts = v.split(",");
    if (parts.length > 2) {
      v = parts[0] + "," + parts.slice(1).join("");
    }  
    return v;
  }; */

  function sanitizeImporto(value) {
    if (!value) return "";
  
    let v = value;
  
    if (typeof v === "string" && v.includes(",")) {
      v = v.replaceAll(".", "").replace(",", ".");
    }
  
    const n = Number(v);
    if (isNaN(n)) return "";
  
    return n.toFixed(2).replace(".", ",");
  }
  


    const handleEditorCommentChange = (content, editor) => {
        setCommentContent(content);
      };

      const handleEditorChange = (content, editor) => {
        setEditorContent(content);
      };
      const handleEditorIpotesiChange = (content, editor) => {
        setEditorIpotesi(content);
      };
      const handleEditorRuoloChange = (content, editor) => {
        setEditorRuolo(content);
      };
    
      const handleClickFabUpdate = (event) => {        
        
            console.log("handleClickFabLock",event);  
            //doPostUpdate (idScheda, praticaBloccataOriginalField, "newValue",String(!praticaBloccata));                          
            doPostGenerateGSFCard(idScheda,formatDateISO(dataSeduta),faseSeduta);
        
    };  
      
    
      const handleClickFabLock = (event) => {        
        //if( properties.verboseLog==1)
            console.log("handleClickFabLock0",praticaBloccataOriginalField);  
            console.log("handleClickFabLock",event,idScheda,praticaBloccataOriginalField,String(!praticaBloccata), !praticaBloccata);  
            doPostUpdate (idScheda, praticaBloccataOriginalField, "newValue",String(!praticaBloccata));                          
            setPraticaBloccata(!praticaBloccata);
            //console.log("handleClickFabLock",praticaBloccataOriginalField,praticaBloccata);  
    };  

    const passing2 = (event) => {        
        if( properties.verboseLog==1)
            console.log("passing2",event);    
        hiddenFileUpload2.current.files=null;
        if( properties.verboseLog==1)
            console.log("42",hiddenFileUpload2);    
        hiddenFileUpload2.current.click();
    };
    //ALLEGATI
    const [openAllegati, setOpenAllegati] = useState(false);
    const [tableAllegati, setTableAllegati] = useState([]);

    const handleOpenAllegati = () => {     
        console.log("OPEN ALLEGATI",homeData);
        const allegati= homeData.filter(item => item.tipo == "allegato")
            .map((item, index) =>  (item));
                    
        setTableAllegati(allegati);                
        console.log("ALLE",allegati);
        setOpenAllegati(true);
    };

    const handleCloseAllegati = () => {            
        setOpenAllegati(false);
      };
    
    const handleDeleteRow = (rowKey) => {
        setTableAllegati(prev =>
          prev.filter(row => row.key !== rowKey)
        );
    };


    const handleSaveAllegati = () => {        
        console.log("Salvataggio:", tableAllegati);      
        //doPostUpdate (idScheda, "allegati", "allegato",file.name);
        doPostUpdate (idScheda, "allegati", "allegati",JSON.stringify(tableAllegati));        
        setOpenAllegati(false);
    };



    const hasFilteredRows = (table) => {
        return table
          ?.slice(2)
          .some(row => row[4] !== "0,00" || row[5] !== "0,00");
      };

      const attachmentsAvailable = (home) =>{
        //console.log("DDDD",home);
        return Array.isArray(home) &&
        home.length > 0 &&
        home.some(item => item.tipo === "allegato");
      };
    //ALLEGATI

// PER DETTAGLIO SPLIT BUDGET
    const [tableContent, setTableContent] = useState([]);
    const [openDettaglioBudget, setOpenDettaglioBudget] = useState(false);
    const visibleDettaglioCols = [3, 4, 5];
    const handleCloseDettaglioBudget = () => {    
        setOpenDettaglioBudget(false);
    };
    const handleOpenDettaglioBudget = (item) => {
        console.log("OPEN22", item, homeData)
        let val=item.table;
        setTableContent(val);        
        setItemContent(item);     
        if(homeData.find(item => item.label === "Importo Anno In Corso").newValue != undefined){
            setEditorAnnoInCorso(sanitizeImporto(homeData.find(item => item.label === "Importo Anno In Corso")?.newValue));
        }
        else{
            setEditorAnnoInCorso(sanitizeImporto(homeData.find(item => item.label === "Importo Anno In Corso")?.value));
        }
        if(homeData.find(item => item.label === "Importo Anno Precedente").newValue != undefined){
            setEditorAnnoPrecedente(sanitizeImporto(homeData.find(item => item.label === "Importo Anno Precedente")?.newValue));
        }
        else{
            setEditorAnnoPrecedente(sanitizeImporto(homeData.find(item => item.label === "Importo Anno Precedente")?.value));
        }          
        setOpenDettaglioBudget(true);
        };
  
    const handleSaveDettaglioBudget = () => {        
        console.log("Salvato:", tableContent,itemContent);      
        if( tableContent.slice(2).reduce((acc, row) =>
        acc + (parseFloat(row[4].replace(/\./g, "").replace(",", ".")) || 0),0) !== parseFloat(editorAnnoInCorso) )
        showAlert("La divisione dell'importo proposto tra le diverse missioni non è corretta. Correggere per poter salvare.");

        else{
        doPostUpdate (idScheda, itemContent.originalField, "table",JSON.stringify(tableContent));        
        setOpenDettaglioBudget(false);
        }
    };




    const handleChangeInTable = (rowIndex, colIndex, value) => {
        const newData = [...tableContent];
        newData[rowIndex][colIndex] = value;
        setTableContent(newData);
      };

    function getMoneyAsStringFromDouble(value, withEuro = false) {
        //console.log(value);        
        if(value.includes(",")){
            value=value.replaceAll(".","");
            value=value.replaceAll(",",".");
        }
        //console.log("S1",value);
        value = Number(value);
        const formatter = new Intl.NumberFormat('it-IT', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
          useGrouping: "always"
        });
      
        const formatted = formatter.format(value);
        //console.log("S2",formatted);;
        return withEuro ? `${formatted} €` : formatted; 
       
    }  

    const handleChangeInAllegatiTable = (rowIndex, field, value) => {
        //handleChangeInAllegatiTable(rowIndex, "label", e.target.value)
        const newData = [...tableAllegati];
        newData[rowIndex][field] = value;
        setTableAllegati(newData);
      };
//
    //START EXECUTIVE SUMMARY
    const [editorExecutive, setEditorExecutive] = useState('');
    const [editorRelazione, setEditorRelazione] = useState('');
    const [openER, setOpenER] = useState(false);
    const [itemRelazione, setItemRelazione] = useState('');
    const handleOpenER = (item) => {
        console.log("OPENER",item);        
        let val= item.newValue || item.value
        let val2= relazioneData.length > 0 ? relazioneData[0] : null;
        setItemRelazione(val2);
        if(val2!= null)
        val2=val2.newValue || val2.value;
        console.log ("OO", val, val2)
        setItemContent(item);
        setEditorExecutive(val || '');
        setEditorRelazione(val2 || '');
        setCommentContent(item.comment||'');
        setOpenER(true);
        };
      
    const handleCloseER = () => {        
        setCommentContent('');
        setItemRelazione('');
        setOpenER(false);
    };
      
    //const handleSaveER = () => {        
      const handleSaveER = async () => {        
          console.log("Salvato:1", editorExecutive);
          console.log("Salvato:2", editorRelazione);                 
          console.log("Salvato:4", commentContent);     
/*                     
          doPostUpdate (idScheda, itemContent.originalField, "newValue",editorExecutive);
          doPostUpdate (idScheda, itemRelazione.originalField, "newValue",editorRelazione);             
          doPostUpdate (idScheda, itemContent.originalField, "comment",commentContent);   
*/
         try {
            await doPostUpdatePromise(idScheda, itemContent.originalField, "newValue",editorExecutive, false);        
            await doPostUpdatePromise(idScheda, itemRelazione.originalField, "newValue",editorRelazione,false);
            await doPostUpdatePromise(idScheda, itemContent.originalField, "comment",commentContent,true);
        } catch (err) {
            console.error("Errore nel salvataggio", err);
        }
          setCommentContent('');     
          setItemRelazione('');
          setOpenER(false);
    };

    const handleEditorExecutiveChange = (content, editor) => {
            setEditorExecutive(content);
    };    
    const handleEditorRelazioneChange = (content, editor) => {
            setEditorRelazione(content);
    };    
    //FINE EXECUTIVE SUMMARY
    
    //PER IPOTESI INTERVENTO
    const [editorRuolo, setEditorRuolo] = useState('');
    const [editorIpotesi, setEditorIpotesi] = useState('');
    //const [editorImporto, setEditorImporto] = useState('');

    const handleOpenII = (item) => {
        console.log("OPENII",item);
        //let val=item.value;
        let val= item.newValue || item.value
        let val2=item.second;
        //console.log("HOII",item);
        //val=val.replaceAll('</p>', '</p><p><br></p>')
        //val2=val2.replaceAll('</p>', '</p><p><br></p>')
        //console.log("VAL",val2);
        setItemContent(item);
        setEditorIpotesi(val || '');
        setEditorRuolo(val2 || '');
        setCommentContent(item.comment||'');
        setOpenII(true);
        };
      
        const handleCloseII = () => {    
            //console.log("Close:", editorContent);      
            setCommentContent('');
            setOpenII(false);
          };
      
        //const handleSaveII = () => {
        const handleSaveII = async () => {                
          console.log("Salvato:1", editorIpotesi);
          console.log("Salvato:2",  editorRuolo);           
          console.log("Salvato:4", commentContent);      
          
          //doPostUpdate (idScheda, itemContent.originalField, "newValue",editorIpotesi);
          //doPostUpdate (idScheda, itemContent.originalField, "secondValue",editorRuolo);             
          //doPostUpdate (idScheda, itemContent.originalField, "comment",commentContent);  
          
          try {
            await doPostUpdatePromise(idScheda, itemContent.originalField, "newValue",editorIpotesi, false);        
            await doPostUpdatePromise(idScheda, itemContent.originalField, "secondValue",editorRuolo, false);
            await doPostUpdatePromise(idScheda, itemContent.originalField, "comment",commentContent,true);
        } catch (err) {
            console.error("Errore nel salvataggio", err);
        }

          

          setCommentContent('');
          //}
          setOpenII(false);
        };

    //PER IPOTESI INTERVENTO

    //IMPORTO PROPOSTO
    const [openImporto, setOpenImporto] = useState(false);
    const [editorAnnoInCorso, setEditorAnnoInCorso] = useState('');
    const [editorAnnoPrecedente, setEditorAnnoPrecedente] = useState('');

    const handleOpenImportoProposto = (val) => {    
        console.log("HO",val, homeData.find(item => item.label === "Importo Anno In Corso").newValue);
        setItemContent(val);   
        if(homeData.find(item => item.label === "Importo Anno In Corso").newValue != undefined){
            setEditorAnnoInCorso(sanitizeImporto(homeData.find(item => item.label === "Importo Anno In Corso")?.newValue));
        }
        else{
            setEditorAnnoInCorso(sanitizeImporto(homeData.find(item => item.label === "Importo Anno In Corso")?.value));
        }
        if(homeData.find(item => item.label === "Importo Anno Precedente").newValue != undefined){
            setEditorAnnoPrecedente(sanitizeImporto(homeData.find(item => item.label === "Importo Anno Precedente")?.newValue));
        }
        else{
            setEditorAnnoPrecedente(sanitizeImporto(homeData.find(item => item.label === "Importo Anno Precedente")?.value));
        }        
        setOpenImporto(true);
    };

    const handleCloseImportoProposto = () => {    
        //console.log("Close:", editorContent);      
        setOpenImporto(false);
    };

    const handleChangeImportoProposto = ( field, value) => {
        console.log("HCIP",field,value);
        if(field=="Importo Anno In Corso")
            setEditorAnnoInCorso(value);
        if(field=="Importo Anno Precedente")
            setEditorAnnoPrecedente(value);        
      };

    //const handleSaveImportoProposto = () => {
    const handleSaveImportoProposto = async () => {   
      
      console.log("Salvando", itemContent);      
      if(parseFloat(editorAnnoInCorso.replace(/\./g, "").replace(",", ".")) + 
        parseFloat(editorAnnoPrecedente.replace(/\./g, "").replace(",", ".")) !==
        parseFloat((homeData.find(item => item.label === "Importo Proposto")?.value || 0))) {
            showAlert("La divisione tra importo anno in corso ed importo anno precedente non corrisponde all'importo proposto. Correggere per poter salvare.");
      }
      else{      
        let aic= itemContent.originalField.replace("ImportoProposto","ImportoAnnoInCorso");
        let ap= itemContent.originalField.replace("ImportoProposto","ImportoAnnoPrecedente");
        console.log("Salvando", aic);      
        console.log("Salvando", ap);      
        //doPostUpdate (idScheda, aic, "newValue",editorAnnoInCorso);
        //doPostUpdate (idScheda, ap, "newValue",editorAnnoPrecedente);
        try {
            await doPostUpdatePromise(idScheda, aic, "newValue",editorAnnoInCorso,false);          
            await doPostUpdatePromise(idScheda, ap, "newValue",editorAnnoPrecedente,true);
          } catch (err) {
            console.error("Errore nel salvataggio", err);
          }

        setOpenImporto(false);
      }
    }
    //IMPORTO PROPOSTO
    

    const handleHide = (val) => {    
        if (!loading) { setLoading(true);}   
        console.log("HIDINIG",val);
        doPostUpdate (idScheda, val.originalField, "hide",false);  
        console.log("HIDE",val.originalField, idScheda);        
        };

    const handleOpen = (val) => {
      //let v=val.value;  
      console.log("HO",val);
      setOpenedLabel(val.label);
      let v = val.newValue || val.value;
      //let val2=v.replaceAll('</p>', '</p><p><br></p>')
      //  console.log("VAL",val2);
      setItemContent(val);
      //setEditorContent(val2 || '');
      setEditorContent(v || '');
      setCommentContent(val.comment||'');
      setOpen(true);
    };
  
    const handleClose = () => {    
        console.log("Close:", editorContent);    
        setCommentContent('');  
        setOpenedLabel(null)
        setOpen(false);
      };
  
    //const handleSave = () => {
    const handleSave = async () => {   
      if (!loading) { setLoading(true);}   
      //doPostUpdate (idScheda, itemContent.originalField, "newValue",editorContent);        
      //doPostUpdate (idScheda, itemContent.originalField, "comment",commentContent);  

      try {
        await doPostUpdatePromise(idScheda, itemContent.originalField, "newValue",editorContent, false);    
        await doPostUpdatePromise(idScheda, itemContent.originalField, "comment",commentContent,true);                          
      } catch (err) {
        console.error("Errore nel salvataggio", err);
      }
      
        setCommentContent('');
        setOpenedLabel(null);
      //}
      setOpen(false);
    };

//    const [color, setColor] = useState([]);

//    var dateStyle = {
//        display: "flex",
//        paddingLeft: "25px",
//    };
//    const id=idScheda;

    const onClickToUpdate= (e ) => {   
        navigate("/schede/"+ idScheda);
    };

    const updateUI = function(jsonData) {
        const keyValuScores = jsonData;
        const homeFieldsItem = Object.entries(keyValuScores.components.home.fields);
        //if( properties.verboseLog==1)
            //console.log("HFI",homeFieldsItem);
        const indexFieldsItem = Object.entries(keyValuScores.index.fields);
        //console.log("IFI",indexFieldsItem);
        var homeItems = [];
        var relazioneItems = [];
        let obiettivo;
        for (var i = 0; i < homeFieldsItem.length; i++) {
            var firstItemCss = "0px";
            var itemBorderColor = "";
            //console.log("WWWWWWW",    homeFieldsItem[i][0]);
            if (i === 0) {
                firstItemCss = "8px";
            }
            if (
                homeFieldsItem[i][1]["componentRef"] ||
                (homeFieldsItem[i][1]["style"] === 0 &&
                    !homeFieldsItem[i][1]["secondValue"] &&
                    !homeFieldsItem[i][1]["comment"])
            ) {
                itemBorderColor = "1px solid #EFEFEF";
            }
            if( properties.verboseLog==1){
                console.log("home", homeFieldsItem[i]);
                console.log("home1",keyValuScores);
            }

            if (homeFieldsItem[i][1]["label"]==="Obiettivo") {
                obiettivo = homeFieldsItem[i][1]["value"];
            }
            var item = {
                componentRef: homeFieldsItem[i][1]["componentRef"],
                label: homeFieldsItem[i][1]["label"],
                value: homeFieldsItem[i][1]["value"],
                style: homeFieldsItem[i][1]["style"],
                second: homeFieldsItem[i][1]["secondValue"],
                comment: homeFieldsItem[i][1]["comment"],
                table: homeFieldsItem[i][1]["table"],
                originalField:homeFieldsItem[i][0],
                newValue:homeFieldsItem[i][1]["newValue"],
                hide:homeFieldsItem[i][1]["hide"],
                itemcss: firstItemCss,
                bordercss: itemBorderColor,
            };
            if(item.table){
                //console.log("EECCE",item.table);
                //item.table.shift();
                const table = typeof item.table === "string"? JSON.parse(item.table): item.table;                
                table.shift();
            }
            homeItems.push(item);
        }   
        //console.log("SSSW1",keyValuScores);
        const allegatiFieldsItem = Object.entries(keyValuScores.components.allegati);
        console.log("SSSW2",allegatiFieldsItem);
        
        var firstItemCss = "0px";
        var itemBorderColor = "";
        for (var i = 0; i < allegatiFieldsItem.length; i++) {
                //console.log("TESE", allegatiFieldsItem[i][1], allegatiFieldsItem[i][1]["data_modifica"]);
                if (allegatiFieldsItem[i][1]["data_modifica"]!= undefined){ 
                //console.log("VER",allegatiFieldsItem[i][1]);
                var item = {
                    componentRef: allegatiFieldsItem[i][1]["componentRef"],
                    label: allegatiFieldsItem[i][1]["label_file"],
                    value: allegatiFieldsItem[i][1]["nome_file"],
                    sezione: allegatiFieldsItem[i][1]["sezione"],
                    posizione: allegatiFieldsItem[i][1]["posizione"],
                    style: allegatiFieldsItem[i][1]["style"],
                    tipo: "allegato",
                    key:allegatiFieldsItem[i][0],
                    data_modifica: allegatiFieldsItem[i][1]["data_modifica"],
                    dimensione: allegatiFieldsItem[i][1]["dimensione"],
                    //second: allegatiFieldsItem[i][1]["secondValue"],
                    //comment: allegatiFieldsItem[i][1]["comment"],
                    //table: allegatiFieldsItem[i][1]["table"],
                    //originalField:allegatiFieldsItem[i][0],
                    //newValue:allegatiFieldsItem[i][1]["newValue"],
                    //hide: allegatiFieldsItem[i][1]["hide"],
                    itemcss: firstItemCss,
                    bordercss: itemBorderColor,
                };
                homeItems.push(item);
            }
        }

        const appoggioFieldsItem = Object.entries(keyValuScores.components.appoggio.fields);
        console.log("PDPM",appoggioFieldsItem);
        for (var i = 0; i < appoggioFieldsItem.length; i++) {            
            if(appoggioFieldsItem[i][1]["label"]=="Importo Anno In Corso"||appoggioFieldsItem[i][1]["label"]=="Importo Anno Precedente" ||appoggioFieldsItem[i][1]["label"]=="Dettagli Importo Proposto"||appoggioFieldsItem[i][1]["label"]=="Importo Proposto"){
                    var firstItemCss = "0px";
                    var itemBorderColor = "";
                    if (
                        appoggioFieldsItem[i][1]["componentRef"] ||
                        (appoggioFieldsItem[i][1]["style"] === 0 &&
                            !appoggioFieldsItem[i][1]["secondValue"] &&
                            !appoggioFieldsItem[i][1]["comment"])
                    ) {
                        itemBorderColor = "1px solid #EFEFEF";
                    }
                    

                    if (appoggioFieldsItem[i][1]["label"]==="Obiettivo") {
                        obiettivo = appoggioFieldsItem[i][1]["value"];
                    }
                    var item = {
                        componentRef: appoggioFieldsItem[i][1]["componentRef"],
                        label: appoggioFieldsItem[i][1]["label"],
                        value: appoggioFieldsItem[i][1]["value"],
                        style: appoggioFieldsItem[i][1]["style"],
                        second: appoggioFieldsItem[i][1]["secondValue"],
                        comment: appoggioFieldsItem[i][1]["comment"],
                        table: appoggioFieldsItem[i][1]["table"],
                        originalField:appoggioFieldsItem[i][0],
                        newValue:appoggioFieldsItem[i][1]["newValue"],
                        hide:appoggioFieldsItem[i][1]["hide"],
                        itemcss: firstItemCss,
                        bordercss: itemBorderColor,
                    };
                    if(item.table){
                     //   item.table.shift();
                     //console.log("EECCE",item.table);
                     //item.table.shift();
                     if(typeof item.table === "string")
                        item.table=JSON.parse(item.table);
                     //const table = typeof item.table === "string"? JSON.parse(item.table): item.table;                
                     //item.table.shift();
                    }
                    homeItems.push(item);
                }
                if(appoggioFieldsItem[i][1]["label"]=="Ultima modifica"){            
                    //console.log("WWW",appoggioFieldsItem[i][1]);
                    const valZ=appoggioFieldsItem[i][1].newValue||appoggioFieldsItem[i][1].value;
                    console.log("UM",valZ);
                    if(valZ=='None')
                        setPraticaUltimaModifica("");
                    else
                        setPraticaUltimaModifica(valZ);
                    //setPraticaUltimaModificaOriginalField(appoggioFieldsItem[i][0]);
                }    
                if(appoggioFieldsItem[i][1]["label"]=="Modificato da"){                    
                    const valZ=appoggioFieldsItem[i][1].newValue||appoggioFieldsItem[i][1].value;
                    console.log("MD",valZ,appoggioFieldsItem);
                    if(valZ=='None')
                        setPraticaModificataDa("");
                    else
                        setPraticaModificataDa(valZ);
                    //setPraticaModificataDaOriginalField(appoggioFieldsItem[i][0]);
                }    
                if(appoggioFieldsItem[i][1]["label"]=="Bloccato"){                    
                    const valZ=appoggioFieldsItem[i][1].newValue||appoggioFieldsItem[i][1].value;
                    console.log("BL",valZ);
                    if(valZ=='false')
                        setPraticaBloccata(false);
                    else
                        setPraticaBloccata(true); 
                    setPraticaBloccataOriginalField(appoggioFieldsItem[i][0]);                                       
                }  
                if(appoggioFieldsItem[i][1]["label"]=="Altre Sedute"){                    
                    const valZ=appoggioFieldsItem[i][1].newValue||appoggioFieldsItem[i][1].value;
                    console.log("ALTRE",valZ);
                    if(valZ=='')
                        setSedutePrecedenti("");
                    else
                        setSedutePrecedenti(valZ);                     
                }    
            }
        
        const relazioneFieldsItem = Object.entries(keyValuScores.components.relazioneannotazioni.fields);
        for (var i = 0; i < relazioneFieldsItem.length; i++) {
            if(relazioneFieldsItem[i][1]["label"]=="Relazione/Annotazioni"){
                    var firstItemCss = "0px";
                    var itemBorderColor = "";
                    if (
                        relazioneFieldsItem[i][1]["componentRef"] ||
                        (relazioneFieldsItem[i][1]["style"] === 0 &&
                            !relazioneFieldsItem[i][1]["secondValue"] &&
                            !relazioneFieldsItem[i][1]["comment"])
                    ) {
                        itemBorderColor = "1px solid #EFEFEF";
                    }
                                     
                    var item = {
                        componentRef: relazioneFieldsItem[i][1]["componentRef"],
                        label: relazioneFieldsItem[i][1]["label"],
                        value: relazioneFieldsItem[i][1]["value"],
                        style: relazioneFieldsItem[i][1]["style"],
                        second: relazioneFieldsItem[i][1]["secondValue"],
                        comment: relazioneFieldsItem[i][1]["comment"],
                        table: relazioneFieldsItem[i][1]["table"],
                        originalField:relazioneFieldsItem[i][0],
                        newValue:relazioneFieldsItem[i][1]["newValue"],
                        hide:relazioneFieldsItem[i][1]["hide"],
                        itemcss: firstItemCss,
                        bordercss: itemBorderColor,
                    };
                    //if(item.table){
                     //   item.table.shift();
                    // console.log("EECCE",item.table);
                     //item.table.shift();
                    // if(typeof item.table === "string")
                    //    item.table=JSON.parse(item.table);
                     //const table = typeof item.table === "string"? JSON.parse(item.table): item.table;                
                     //item.table.shift();
                    //}
                    relazioneItems.push(item);
                }
            }
        


        console.log("HOME",homeItems);     
        console.log("REL",relazioneItems);     
        setHomeData(homeItems);
        setRelazioneData(relazioneItems)
             
        var keyExist = keyValuScores.hasOwnProperty("scoreboard");
        if (keyExist) {
            setScore(keyValuScores.scoreboard.score1Level);
        }  
        setLoading(false);
    }

    const doPostGenerateGSFCard = function(idScheda, dataSeduta, faseSeduta) {  
        setLoading(true);   
        var xhr = new XMLHttpRequest();        
        
        xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/generateGSFPratica.php',true);
        xhr.withCredentials = true;
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  
        xhr.onload = function (e) {      
              if (xhr.readyState === 4) {
                  if (xhr.status === 200) {                             
                      //console.log("OK92",xhr);
                      var responseText = xhr.responseText;                    
                      console.log("OK92",responseText);
                      //
                      var obj=JSON.parse(responseText);
                      console.log("id1",obj.idScheda);
                      console.log("id2",obj.dataSeduta);
                      console.log("id3",obj.faseSeduta);
                      
                      //if( properties.verboseLog==1)
                      //  console.log("OK193",obj,responseText);   
                      setLoading(false);     
                      //const SchedaInfo = JSON.parse(obj.content);
                      //console.log("SI",SchedaInfo);                
                      //updateUI(SchedaInfo);
                      //navigate("/schede2/"+obj.dataSeduta+"/"+obj.faseSeduta+"/"+obj.idScheda);       
                      doPostSeduta2();
                }
                  else {                                
                      //alert("Errore recuperando i dati dell'indice");
                      setAlert(
                        <SweetAlert
                        warning
                        closeOnClickOutside ={true}
                        showCancel ={false}
                        showConfirm={false}
                        style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                        title={"Si è verificato un errore generando la scheda per il Fascicolo di Comitato. Controllare il numero di pratica inserito e riprovare"}
                        onConfirm={() => {
                            setAlert(null);                            
                        }}           
                        onCancel={() => {
                            setAlert(null);                          
                        }}
                      >
                      </SweetAlert>
                      );  
                      setLoading(false);  
                      //navigate("/indice/init",{ replace: true });                                    
                  }
              }
          };
  
          xhr.onerror = function (e) {
              console.error("Error 2", xhr.statusText);
          };
                        
          let urlEncodedData = "data=" + dataSeduta+ "&fase="+faseSeduta+"&idScheda="+idScheda;
          //if( properties.verboseLog==1)
          console.log("WERE",urlEncodedData);
          xhr.send(urlEncodedData);  
      }
  
      function formatDateISO(date) {
        const day = date.substring(0, 2);
        const month = date.substring(2, 4);
        const year = date.substring(4, 8);
        return `${year}-${month}-${day}`;
      }


    const doPostSeduta2 = function() {
    
        var xhr2 = new XMLHttpRequest();                        
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/checkSchedaPreview.php',true);
        xhr2.withCredentials = true;
        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
        xhr2.onload = function (e) {      
            if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {                              
                    if( properties.verboseLog==1)
                        console.log("OK92",xhr2);
                    var responseText = xhr2.responseText;                    
                    var obj=JSON.parse(responseText);
                    if( properties.verboseLog==1)
                        console.log("OK93",obj);          
                    if(obj.status==="201" ){                         
                        console.log("OK CARD 201",xhr2);                                  
                        const SchedaInfo = JSON.parse(obj.content);
                        //console.log("SI",SchedaInfo);                
                        updateUI(SchedaInfo);
                    }                   
                } 
                else {
                    console.error("Error 1", xhr2.statusText);          
                    //window.alert("Errore recuperando la scheda 1");    
                    setLoading(true);      
                    //doPostGenerateGSFCard(idScheda,dataSeduta,faseSeduta);
                    //navigate("/editor",{ replace: true });                      
                    doPostGenerateGSFCard(idScheda,formatDateISO(dataSeduta),faseSeduta);
                }
            }
        };

        xhr2.onerror = function (e) {
            console.error("Error 22", xhr2.statusText);
        };
    
        let urlEncodedData = "ids=" + idScheda+ "&data="+dataSeduta+ "&fase="+faseSeduta;        
        xhr2.send(urlEncodedData);
    }
    
    const doPostUpdate = function(idScheda, entry, attribute, value) {
    
        var xhr2 = new XMLHttpRequest();                        
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/updateSchedaPreview.php',true);
        xhr2.withCredentials = true;
        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
        xhr2.onload = function (e) {      
            if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {                              
                    if( properties.verboseLog==1)
                        console.log("OK92",xhr2);
                    var responseText = xhr2.responseText;                    
                    var obj=JSON.parse(responseText);
                    if( properties.verboseLog==1)
                        console.log("OK93",obj);          
                    if(obj.status==="201" ){                         
                        console.log("OK CARD 201",xhr2);                                      
                        const SchedaInfo = JSON.parse(obj.content);
                        updateUI(SchedaInfo);
                        
                    }
                } 
                else {
                    //console.error("Error 1", xhr.statusText);          
                    window.alert("Errore recuperando la scheda 1");                      
                    navigate("/editor",{ replace: true });                      
                }
            }
        };
        xhr2.onerror = function (e) {
            console.error("Error 22", xhr2.statusText);
        };       
        let encValue= btoa(unescape(encodeURIComponent(value)))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
        
        //console.log("IDDIIO", value, encValue);  
        
        let urlEncodedData = "ids=" + idScheda + "&data="+dataSeduta+ "&fase="+faseSeduta+ "&key="+entry+"&attribute="+attribute+"&value="+encodeURIComponent(encValue);
        console.log(urlEncodedData);      
        xhr2.send(urlEncodedData);
    }



    const doPostUpdatePromise = function(idScheda, entry, attribute, value, update) {
        return new Promise((resolve, reject) => {
            var xhr2 = new XMLHttpRequest();
            xhr2.open( "POST", properties.productionUrl +properties.productionUrlSuffix +"/core/rest/updateSchedaPreview.php",true);        
            xhr2.withCredentials = true;
            xhr2.setRequestHeader("Content-type","application/x-www-form-urlencoded");
        
            xhr2.onload = function () {
              if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {
                  try {
                    const obj = JSON.parse(xhr2.responseText);        
                    if (obj.status === "201") {
                      const SchedaInfo = JSON.parse(obj.content);                                            
                      resolve(obj); 
                      if(update)
                      updateUI(SchedaInfo);  
                    } else {
                      window.alert("Errore recuperando la scheda 1");                      
                      reject(obj);
                    }
                  } catch (err) {
                    reject(err);
                  }
                } else {
                  reject(new Error("HTTP error " + xhr2.status));
                }
              }
            };
        
            xhr2.onerror = function () {
              reject(new Error("Network error"));
            };
        
            let encValue= btoa(unescape(encodeURIComponent(value)))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
                        
        let urlEncodedData = "ids=" + idScheda + "&data="+dataSeduta+ "&fase="+faseSeduta+ "&key="+entry+"&attribute="+attribute+"&value="+encodeURIComponent(encValue);
        console.log(urlEncodedData);              
        xhr2.send(urlEncodedData);
        });
    }

    const onFileChange2= (e ) => {   
        console.log("ew2",e); 
        
            
        if (!loading) { setLoading(true);} 
        e.stopPropagation();                     
        let endpoint = properties.productionUrl+properties.productionUrlSuffix +"/core/rest/caricaAllegato.php";   
        let file=e.target.files[0];
        var bodyFormData=new FormData();
        if( properties.verboseLog==1)
            console.log("cire",file);
        bodyFormData.append('UploadedFile', file);
        bodyFormData.append('fileName', file.name);
        bodyFormData.append('id_scheda', idScheda);
        bodyFormData.append('data', dataSeduta);
        bodyFormData.append('fase', faseSeduta);
        axios({
            method: 'post',
            url: endpoint,
            data: bodyFormData, 
            withCredentials: true, 
            headers: {'Content-Type': 'multipart/form-data' }
        })
        .then(function (response) {                    
            setLoading(false);
            //if( properties.verboseLog==1)
            console.log("EEEEEEEEEEEEHHHHHH",response, file.name, itemContent.originalField);
            //doPostUpdate (idScheda, "allegati", "allegato",file.name);
            doPostUpdate (idScheda, "allegati", "allegato",response.data.fileName);
            doPostSeduta2();
            //allegatiRef.current?.scrollIntoView({ behavior: "smooth" });
            //console.log("EEEEEEEEEEEEHHHHHH",response, file.name, itemContent.originalField);
        })
        .catch(function (response) {            
            console.log("ERRORE1",response);
        });
        
    };


    useEffect(() => {              
        updateSeduta(dataSeduta,doPostSeduta2,updateUI);        
    }, []);
    
    const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
        height: 10,
        borderRadius: 5,
        backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 300 : 700], 
        '& .MuiLinearProgress-bar': {
          borderRadius: 5,
          backgroundColor: '#5cb85c',
        },
      }));

    const openScoreBoard = (id) => {
        navigate("/schede/"+ idScheda + "/scoreboard");  
    };

    const goFinalInfo = (refname) => {
        if( properties.verboseLog==1)
            console.log("called goFinalInfo");
        if (refname) {            
            //navigate("/schede2/"+ idScheda + "/" + refname);  
            navigate("/schede2/"+dataSeduta+"/"+faseSeduta+"/"+idScheda+ "/" + refname);  
        }
    };

    return (        
        <div> 
        {loading ? (
            <div key={uuidv4()} style={{ width:"25%",   display: "flex", 
            marginLeft: "auto", marginRight: "auto" }}> 
             <ThreeDots color="#30720f" height='350' width='150'/>
             </div> 
        ):(
        <div className="content">
            <Tooltip title="Mostra anteprima" placement="left">
                <Fab aria-label="add" onClick={(event) => {onClickToUpdate(event) }}                
                    style={{
                        margin: 0,
                        background: "#30720f",
                        top: 'auto',
                        right: 5,
                        //bottom: 90,                    
                        bottom:155,
                        left: 'auto',
                        position: 'fixed',}}>                    
                        <PreviewIcon />
             
                </Fab>   
            </Tooltip>
            <Tooltip title="Carica Nuovo Allegato" placement="left" disabled={praticaBloccata && localStorage.getItem("ruolo")!="5"}>
                <Fab aria-label="add" onClick={passing2}          
                    style={{
                        margin: 0,
                        background: "#30720f",
                        top: 'auto',
                        right: 5,
                        //bottom: 155,                    
                        bottom: 220,                    
                        left: 'auto',
                        position: 'fixed',}}>                    
                        <AttachFileIcon />
                        <AddIcon fontSize="small" sx={{ position: "absolute", bottom: 6, right: 6, fontSize: "20px" }}/>
             
                </Fab>   
            </Tooltip>
           
            <input id="fileupload00" type="file" name="file" ref={hiddenFileUpload2}
                                onChange={onFileChange2} style={{ display: "none" }} /> 
             <Tooltip title={praticaBloccata ? "Abilita modifica" : "Blocca modifica"} placement="left">
                <Fab aria-label="add" onClick={handleClickFabLock}          
                    style={{
                        margin: 0,
                        background: "#F57C00 ",
                        top: 'auto',
                        right: 5,
                        bottom: 25,                    
                        left: 'auto',
                        position: 'fixed',}}>                                            
                        {praticaBloccata ?(
                            <NoEncryptionGmailerrorredIcon />
                        ):(
                            <HttpsIcon />
                        )}
                        
             
                </Fab>   
            </Tooltip>
            
            <Tooltip title={"Aggiorna dati da EroWeb"} placement="left"  PopperProps={{disablePortal: true}}>
                <div style={{ display: "inline-flex", position: "fixed", bottom: 90, right: 5  }}>
                    <Fab aria-label="add" onClick={handleClickFabUpdate}   
                        disabled={praticaBloccata ? true: false}       
                        style={{
                            margin: 0,
                            background: "#D84A38",
                            //top: 'auto',
                            //right: 5,
                            //bottom: 220,                    
                            //bottom: 90,                    
                            //left: 'auto',
                            //position: 'fixed',
                        }}>                                                                 
                            <SystemUpdateAltIcon />
                    </Fab>   
                </div>
            </Tooltip>            
            <div>
                <div className="common-list" key={"007"}
                    style={{ position:"relative", margin: "0px", paddingLeft: "70px",
                             borderRadius: "0px", borderTopLeftRadius:"8px" , borderTopRightRadius: "8px",                                                                
                             borderBottomLeftRadius:"8px" , borderBottomRightRadius: "8px",                                                                
                             borderBottom:  "1px solid #EFEFEF",
                                marginBottom:"5px",                                                                                              
                                backgroundColor:"white",
                                border: "none",                                                                
                                //marginLeft: item.hide ? "50px": "0px"
                            }}                          
                        >
                            <div style={{ display:"flex", width: "100%", padding: "0px 25px",margin: "5px 0px",
                                            textAlign: "left"}} >
                                        <p className="text importantText">
                                           Numero Pratica:
                                        </p>   
                                        <p style={{paddingLeft:"20px"}}>{idScheda}</p>
                                        {praticaBloccata? (
                                        <Chip style={{marginLeft:"20px", marginTop:"8px", backgroundColor:"#BCF3A1"}}
                                            label="PRONTA PER IL COMITATO"                                            
                                            icon={<DoneIcon />}
                                            
                                        />
                                        ):(
                                            <Chip style={{marginLeft:"20px", marginTop:"8px", backgroundColor:"#F6BD60", color:"black"}}
                                            label="IN PREPARAZIONE"                                            
                                            icon={<DriveFileRenameOutlineIcon />}
                                        />  
                                        )}
                                      {/*}  {sedutePrecedenti? (
                                            <Box>
                                      
                                      
                                            <Stack direction="row" spacing={1} flexWrap="wrap">
                                              {sedutePrecedenti?.split("#").filter(Boolean).map((date, index) => (
                                                <Chip
                                                  key={index}
                                                  icon={<EventIcon />}
                                                  label={formatDate(date)}
                                                  style={{marginLeft:"20px", marginTop:"8px"}}
                                                  clickable
                                                  color="primary"
                                                  variant="filled"
                                                  onClick={() => handleChipClick(date)}
                                                  sx={{
                                                    mb: 1,
                                                    cursor: "pointer",
                                                    "&:hover": {
                                                      boxShadow: 2,
                                                    }
                                                  }}
                                                />
                                              ))}
                                            </Stack>
                                          </Box>
                                            ):(
                                                <></>
                                            )
                                        } */}
                            </div>
                
                </div>
                {sedutePrecedenti && 
                <div className="common-list" key={"007"}
                style={{ position:"relative", margin: "0px", paddingLeft: "70px",
                         borderRadius: "0px", borderTopLeftRadius:"8px" , borderTopRightRadius: "8px",                                                                
                         borderBottomLeftRadius:"8px" , borderBottomRightRadius: "8px",                                                                
                         borderBottom:  "1px solid #EFEFEF",
                            marginBottom:"5px",                                                                                              
                            backgroundColor:"white",
                            border: "none",                                                                
                            //marginLeft: item.hide ? "50px": "0px"
                        }}                          
                    >
                        <div style={{ display:"flex", width: "100%", padding: "0px 25px",margin: "5px 0px",
                                        textAlign: "left"}} >
                                    <p className="text importantText">
                                       Altre sedute in cui la pratica è andata in Comitato:
                                    </p>                                                                                                                                                   
                                        <Box>                                        
                                  
                                        <Stack direction="row" spacing={1} flexWrap="wrap">
                                            {/** 
                                          {sedutePrecedenti?.split("#").filter(Boolean).map((date, index) => (
                                            <Chip
                                              key={index}
                                              icon={<EventIcon />}
                                              label={formatDate(date)}
                                              style={{marginLeft:"20px", marginTop:"8px",backgroundColor: "#30720F", color:"black"}}
                                              clickable
                                              color="primary"
                                              variant="filled"
                                              onClick={() => handleChipClick(date)}
                                              sx={{
                                                mb: 1,
                                                cursor: "pointer",
                                                "&:hover": {
                                                  boxShadow: 2,
                                                }
                                              }}
                                            />
                                            ))}*/}
                                            {sedutePrecedenti?.split("#").filter(Boolean).map((entry, index) => {
                                                    const [date, extra] = entry.split("_", 2);
                                                    const hasExtra = Boolean(extra);
                                                    if (hasExtra) {
                                                        return null; 
                                                      }
                                                    return (                                                                                                           
                                                        <Badge badgeContent={
                                                            hasExtra? "M" : ""} 
                                                            //color="#30720E" 
                                                            sx={{
                                                                "& .MuiBadge-badge": {
                                                                  backgroundColor: "#30720E",
                                                                  color: "white",
                                                                },
                                                              }}
                                                            anchorOrigin={{
                                                            vertical: 'bottom',
                                                            horizontal: 'right',
                                                          }}
                                                          invisible={hasExtra? false : true}
                                                          >
                                                        <Chip
                                                        key={index}                                                        
                                                        icon={<EventIcon />}
                                                        label={formatDate(date)}
                                                        clickable
                                                        variant="filled"
                                                        onClick={() =>
                                                        hasExtra
                                                            ? handleChipClickWithMamma(date, extra)
                                                            : handleChipClick(date)
                                                        }
                                                        sx={{
                                                        ml: "20px",
                                                        mt: "8px",
                                                        backgroundColor: "#A2EE7D",
                                                        color: "black",
                                                        cursor: "pointer",
                                                        "&:hover": {
                                                            backgroundColor: "#30720E",
                                                            boxShadow: 2,
                                                        },
                                                        }}
                                                    />
                                                        </Badge>
                                                    
                                                    );
                                                })}
                                        </Stack>
                                      </Box>                                                                            
                        </div>            
                </div>
                }


                {homeData.length > 0 &&
                    homeData.filter(item => item.tipo !== "allegato" && item.label !== "Importo Anno In Corso" && item.label !== "Importo Anno Precedente")
                    .map((item, index) =>  (    
                                                                    
                        <div
                            className="common-list"
                            key={index}
                            style={{          
                                position:"relative",                      
                                margin: "0px",
                                paddingLeft: "70px",
                                borderRadius: "0px",
                                borderTopLeftRadius: item.itemcss,
                                borderTopRightRadius: item.itemcss,
                                borderBottom: item.bordercss,    
                                marginBottom:"5px",                                                                                              
                                backgroundColor: item.hide ?"#f0f0f0" :"white",
                                border: item.hide ?"2px dashed #999": "none",
                                opacity: item.hide ? 0.6: 1 ,                                
                                textDecoration: item.hide ? "line-through" : "none",
                                //marginLeft: item.hide ? "50px": "0px"
                            }}                          
                        >

                        {/*{item.label !== "Ragione Sociale" &&item.label !== "Denominazione iniziativa" ? (*/}
                        {/**{item.label !== "Denominazione iniziativa" ? (*/}
                         <div style={{ position: "absolute", top: "25%", left: 4, display: "flex", gap:1 }}>                            
                         <div style={{ width: 24 }}>
                            {item.label=="Ipotesi d'Intervento" && localStorage.getItem("ruolo")!="5" && praticaBloccata!=true?(  
                            console.log("VER1",item.label, localStorage.getItem("ruolo") ,praticaBloccata),                                                              
                            <IconButton size="small" onClick={() => handleOpenII(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>
                            ):
                            item.label=="Ipotesi d'Intervento" && localStorage.getItem("ruolo")=="5" ?(                                                                
                                <IconButton size="small" onClick={() => handleOpenII(item)}>
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            ):
                            item.label=="Dettagli Importo Proposto" && localStorage.getItem("ruolo")!="5" && praticaBloccata!=true?(  
                                <IconButton size="small" onClick={() => handleOpenDettaglioBudget(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>                          
                            ):

                            item.label=="Dettagli Importo Proposto" && localStorage.getItem("ruolo")=="5"?(      
                                <IconButton size="small" onClick={() => handleOpenDettaglioBudget(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>                          
                            ):
                            item.label=="Executive Summary" && localStorage.getItem("ruolo")!="5" && praticaBloccata!=true ?(      
                                <IconButton size="small" onClick={() => handleOpenER(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>                          
                            ):

                            item.label=="Executive Summary" && localStorage.getItem("ruolo")=="5"?(      
                                <IconButton size="small" onClick={() => handleOpenER(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>                          
                            ):                            
                            item.label=="Importo Proposto" && localStorage.getItem("ruolo")!="5" && praticaBloccata!=true ?(      
                                <IconButton size="small" onClick={() => handleOpenImportoProposto(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>                          
                            ):
                            item.label=="Importo Proposto" && localStorage.getItem("ruolo")=="5"?(      
                                <IconButton size="small" onClick={() => handleOpenImportoProposto(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>                          
                            ):
                            item.tipo != "allegato" && item.label!="Importo Proposto" &&item.label!="Executive Summary"  &&item.label!="Dettagli Importo Proposto" &&item.label!="Ipotesi d'Intervento" && item.label!="Importo Anno Precedente" &&  item.label!="Importo Anno In Corso" &&  item.label!="Ragione Sociale" &&  item.label!="Obiettivo" &&  item.label!="Missione" && localStorage.getItem("ruolo")!="5" && praticaBloccata!=true?
                            (                                  
                                <IconButton size="small" onClick={() => handleOpen(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>
                            )
                            :
                            item.tipo != "allegato" && item.label!="Importo Proposto" &&item.label!="Executive Summary"  &&item.label!="Dettagli Importo Proposto" &&item.label!="Ipotesi d'Intervento" && item.label!="Importo Anno Precedente" &&  item.label!="Importo Anno In Corso" &&  item.label!="Ragione Sociale" &&  item.label!="Obiettivo" &&  item.label!="Missione" && localStorage.getItem("ruolo")=="5"?
                            (                                  
                                <IconButton size="small" onClick={() => handleOpen(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>
                            )
                            :(<></>)                         
                        }
                        </div>    
                        <div style={{ width: 24 }}>
                        {  item.tipo != "allegato" &&  item.label!="Denominazione iniziativa" &&  item.label!="Importo Anno Precedente" &&  item.label!="Importo Anno In Corso" &&  item.label!=="Dettagli Importo Proposto" &&  item.label!=="Importo Proposto" && localStorage.getItem("ruolo")!="5" && praticaBloccata!=true?                            
                            (                            
                            <IconButton size="small" onClick={() => handleHide(item)}>
                                <VisibilityOffIcon fontSize="small" />
                            </IconButton>
                            )
                            :
                            item.tipo != "allegato" &&  item.label!="Denominazione iniziativa" &&  item.label!="Importo Anno Precedente" &&  item.label!="Importo Anno In Corso" &&  item.label!=="Dettagli Importo Proposto" &&  item.label!=="Importo Proposto" && localStorage.getItem("ruolo")=="5"?                            
                            (                            
                            <IconButton size="small" onClick={() => handleHide(item)}>
                                <VisibilityOffIcon fontSize="small" />
                            </IconButton>
                            )
                            :
                            (<></>)}
                            </div> 
                        </div> 
                        {/*}):(<></>)}*/}
                        
                            {item.componentRef && !item.comment ? (
                                item.label === "Executive Summary" ? (       
                                    //console.log("PDD",item.newValue, item.value),                           
                                    <div style={{ display:"block", width: "100%", padding: "0px 25px", margin: "20px 0px",
                                            textAlign: "left", cursor: "pointer"}} onClick={() => goFinalInfo(item.componentRef)}>
                                        <p className="text importantText">
                                           {item.label}:
                                        </p>                                      
                                        
                                        <div className="text" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>
                                        {item.table ? (
                                            item.table.map((extraitem, index) => (
                                            //console.log("uff",item),
                                                <div key={index} style={{ paddingBottom: "20px" }}>  
                                                    {/*<p className="text"                                            
                                                        dangerouslySetInnerHTML={{__html: extraitem[3]}} />  */}
                                                    <div className="text" style={{ whiteSpace: 'normal' }}
                                                        dangerouslySetInnerHTML={{ __html: extraitem[3]}}/>
                                                </div>
                                            ))
                                    ) : ( <></> )}
                                    </div>
                                ) : (  /** DENOMINZA INIZIATIVA E RAGIONE SOCIALE*/                      
                                    <div style={{ display:"block", width: "100%", padding: "0px 25px", margin: "20px 0px",
                                            textAlign: "left", cursor: "pointer",  }}
                                          onClick={() => goFinalInfo(item.componentRef)}>
                                        <p className="text importantText textInLine "> {item.label}: </p>
                                        {/*<p className="text normalTextInLine"
                                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value }}/>        */}
                                              <div className="text normalTextInLine" style={{ whiteSpace: 'normal' }}
                                                    dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>
                                    </div>
                                )
                            ) : !item.componentRef && !item.comment && (item.style === 0 || item.style === 2) ? (
                                item.label === "Executive Summary" ? (

                                    <div style={{ textAlign: "left", paddingLeft: "25px", paddingRight: "25px" }}>
                                        <p className="text importantText">
                                            {item.label}:
                                        </p>                                        
                                        <div style={{ paddingBottom: "20px", whiteSpace: 'pre-wrap' }}>      
                                            <div className="text" style={{ whiteSpace: 'normal' }}
                                                    dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>                   
                                            {/*<p className="text" style={{whiteSpace: 'pre-wrap' }}
                                                dangerouslySetInnerHTML={{__html: item.newValue || item.value }}/>*/}                                            
                                        </div>

                                        {item.table &&
                                            item.table.map(
                                                (extraitem, index) => (                                            
                                                    <div key={index} style={{ paddingBottom:"20px" }} >
                                                        {/*<p className="text normalTextInLine"  style={{ whiteSpace: 'pre-wrap' }}
                                                            dangerouslySetInnerHTML={{__html: extraitem[3],}}/>*/}
                                                            <div className="text normalTextInLine" style={{ whiteSpace: 'normal' }}
                                                                dangerouslySetInnerHTML={{ __html: extraitem[3]}}/>                   
                                                    </div>   
                                                )
                                        )}
                                    </div>
                                ) : item.label === "Descrizione" ? (  
                                    //console.log("e122",item.value),                              
                                    <div style={{textAlign: "left", padding: "0px 15px"}}>
                                        <p className="text importantText">
                                            {item.label}:
                                        </p>
                                        <p className="text" style={{textAlign: "justify" }}>
                                            {item.newValue || item.value}
                                        </p>
                                    </div>
                                ): item.label === "Importo Anno Precedente" || item.label === "Importo Anno In Corso" ?(                                   
                                    <div></div>
                                ):item.label === "Importo Proposto"   ? (  
                                    <div style={{ width: "100%",   paddingRight: "25px"}}>
                                        <div style={{ textAlign: "left", padding: "0px 25px", display: "flex", gap: "20px"}}>
                                            <p className="text importantText">
                                                {item.label}:
                                            </p>
                                            <p className="text" style={{ textAlign: "justify" }}> 
                                                {getMoneyAsStringFromDouble(item.newValue || item.value,true)}
                                            </p>
                                        </div>
                                        <div style={{ flex: 1, marginBottom: '16px',   position:"relative", margin: "0px",  gap: "20px",                                                    
                                            backgroundColor :"white", display: "flex", textAlign: "left", paddingLeft:"25px", width: "100%" }}>   
                                            <table style={{borderCollapse: "collapse", width: "100%", marginBottom:"10px", marginRight:"10px" }}>
                                                <thead>
                                                    <tr>                                                   
                                                        <th key={"lab-01"} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", fontSize:"14px", }}>
                                                        {"Importo Anno In Corso"}
                                                        </th>
                                                        <th key={"lab-02"} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", fontSize:"14px", }}>
                                                        {"Importo Anno Precedente"}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>                                                                                                                                            
                                                        <tr key={"val-01"} style={{height:"40px"}}>
                                                            {homeData.find(item => item.label === "Importo Anno In Corso").newValue != undefined ?(
                                                                console.log("MAD2",homeData.find(item => item.label === "Importo Anno In Corso")?.newValue,getMoneyAsStringFromDouble(homeData.find(item => item.label === "Importo Anno In Corso")?.newValue,true)),
                                                                <td key={"val-0101"} style={{border: "1px solid #ccc", padding: 8 }}>        
                                                                    {getMoneyAsStringFromDouble(homeData.find(item => item.label === "Importo Anno In Corso")?.newValue,true)}
                                                                </td>
                                                            ):(
                                                                <td key={"val-0101"} style={{border: "1px solid #ccc", padding: 8 }}>        
                                                                    {getMoneyAsStringFromDouble(homeData.find(item => item.label === "Importo Anno In Corso")?.value,true)}
                                                                </td>    
                                                            )}
                                                                
                                                            {homeData.find(item => item.label === "Importo Anno Precedente").newValue != undefined ?(
                                                                console.log("MAD",homeData.find(item => item.label === "Importo Anno Precedente")?.newValue,getMoneyAsStringFromDouble(homeData.find(item => item.label === "Importo Anno Precedente")?.newValue,true)),
                                                                <td key={"val-0102"} style={{border: "1px solid #ccc", padding: 8 }}>        
                                                                    {getMoneyAsStringFromDouble(homeData.find(item => item.label === "Importo Anno Precedente")?.newValue,true)} 
                                                                </td>                                                                        
                                                            ):(
                                                                <td key={"val-0102"} style={{border: "1px solid #ccc", padding: 8 }}>        
                                                                    {getMoneyAsStringFromDouble(homeData.find(item => item.label === "Importo Anno Precedente")?.value,true)} 
                                                                </td>                                                                        
                                                            )}                                                                                        
                                                        </tr>                                                
                                                </tbody>
                                            </table>                                      
                                        </div>
                                    </div>
                                ): item.label === "Dettagli Importo Proposto" ? (                                      
                                    <div style={{ textAlign: "left", padding: "0px 0px", paddingLeft:"25px", width: "100%", paddingRight:"10px"}}>
                                        <p className="text importantText">
                                            {item.label}:
                                        </p>
                                        
                                        <table style={{borderCollapse: "collapse", width: "100%", marginBottom:"10px", marginRight:"10px" }}>
                                            <thead>
                                                <tr >                                                
                                                    {visibleDettaglioCols.map((colIndex) => (
                                                        <th key={colIndex} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", fontSize:"14px", }}>
                                                            {item.table[0]?.[colIndex]}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {hasFilteredRows(item.table) ? (
                                                item.table.slice(2).filter(row => row[4] !== "0,00" || row[5] !== "0,00").map((row, rowIndex) => (                                                
                                                    <tr key={rowIndex} style={{height:"40px"}}>
                                                        {visibleDettaglioCols.map((colIndex) => (                                                                  
                                                                <td key={colIndex} style={{border: "1px solid #ccc", padding: 8 }}>
                                                                {colIndex === 3 
                                                                    ? row[colIndex] 
                                                                    : getMoneyAsStringFromDouble(row[colIndex], true)
                                                                }
                                                            </td>   
                                                        ))}   
                                                    </tr>   
                                                ))
                                            ):(
                                                <tr>
                                                <td colSpan={visibleDettaglioCols.length} style={{ textAlign: 'center', color: '#888' }}>
                                                  Nessun dato caricato
                                                </td>
                                              </tr> 
                                            )}
                                            </tbody>
                                        </table>                                        
                                    </div>
                                ): (                                 
                                    <div style={{ paddingLeft: "25px", display:"inline", textAlign: "left", padding: "0px 25px", margin: "20px 0px"}}>
                                        <p className="text importantText textInLine" >
                                            {item.label}:
                                        </p>
                                        {/*<p className="text normalTextInLine" style={{ paddingRight: "25px", whiteSpace: 'pre-wrap' }}
                                            dangerouslySetInnerHTML={{__html: item.newValue || item.value,}}/>*/}
                                        <div className="text normalTextInLine" style={{ whiteSpace: 'normal',paddingRight: "25px" }}
                                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>                   
                                    </div>
                                )) : item.style && item.second ? (
                                    //console.log("II",item),
                                    <div style={{ background: "#a2ee7d", color: "#4B0307", textAlign: "left", padding: "0px 25px", width:"100%" }} className="company-info">
                                        <Accordion style={{ background: "#a2ee7d", boxShadow: "unset"}}>
                                            <AccordionSummary expandIcon={<InfoIcon style={{ color: "#30720f", top: "-32px !important",background:"unset !important" }} /> }
                                                    aria-controls="panel1a-content" id="panel1a-header"
                                                    style={{userSelect: "text", padding: "0px", flexDirection: "unset"}}>
                                                <Typography component={'div'}>
                                                    <div style={{ display: "flex",alignItems: "center", justifyContent: "space-between"}}>
                                                        <p className="text importantText" > {item.label}: </p>
                                                    </div>
                                                    {/*<p className="text" style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{__html: item.newValue || item.value }} />                                                */}
                                                    <div className="text" style={{ whiteSpace: 'normal' }}
                                                        dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>                   
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails style={{ padding: "0px" }}>
                                                <Typography component={'div'}>                                                
                                                    <p className="text importantText"> Ruolo della compagnia: </p>
                                                    {/*<p className="text" style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{__html: item.second}}/>    */}
                                                    <div className="text" style={{ whiteSpace: 'normal' }}
                                                        dangerouslySetInnerHTML={{ __html: item.second}}/>                   
                                                </Typography>
                                            </AccordionDetails>
                                        </Accordion>
                                        {item.comment ? (                                                                            
                                                <div style={{ color: "#879497", padding: "0px 25px", border: "1px solid #30720f", borderRadius: "20px", margin: "40px 0px" }}>
                                                    <p className="text" style={{ fontSize: "14px" }}> Commento: </p>

                                                    <div className="text" style={{ whiteSpace: 'normal' }}
                                                        dangerouslySetInnerHTML={{ __html: item.comment}}/>
                                                    {/*<p className="text" style={{ whiteSpace: 'pre-wrap', fontSize: "14px" }} dangerouslySetInnerHTML={{__html: item.comment }}/>  */}
                                                </div>                                            
                                        ):(<></>)}                                
                                    </div>
                                ) : item.comment && item.label!="Elementi di valutazione"? (                                
                                    <div style={{ textAlign: "left", padding: "0px 25px",  width:"100%" }} >
                                        <div>
                                            <p className="text importantText"> {item.label}: </p>
                                            <div className="text" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>
                                            {/*<p className="text" style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{__html: item.newValue || item.value}}/>                                               */}
                                        </div>
                                        <div style={{ color: "#879497", padding: "0px 25px", border: "1px solid #30720f", borderRadius: "20px", margin: "40px 0px" }}>
                                            <p className="text" style={{ fontSize: "14px" }}> Commento: </p>
                                            <div className="text" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: item.comment}}/>
                                            {/*<p className="text" style={{ whiteSpace: 'pre-wrap', fontSize: "14px" }} dangerouslySetInnerHTML={{__html: item.comment }}/>  */}
                                        </div>
                                    </div>
                                ) : item.comment && item.label=="Elementi di valutazione"? (                                
                                    <div style={{ textAlign: "left", padding: "0px 25px",  backgroundColor:"rgb(162, 238, 125)", width:"100%" }} >
                                        <div>
                                            <p className="text importantText"> {item.label}: </p>
                                            {/*<p className="text" style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{__html: item.newValue || item.value}}/>                                               */}
                                            <div className="text" style={{ whiteSpace: 'normal' }}
                                                        dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>  
                                        </div>
                                        <div style={{ color: "#879497", padding: "0px 25px", border: "1px solid #30720f", borderRadius: "20px", margin: "40px 0px" }}>
                                            <p className="text" style={{ fontSize: "14px" }}> Commento: </p>
                                            {/*<p className="text" style={{ whiteSpace: 'pre-wrap', fontSize: "14px" }} dangerouslySetInnerHTML={{__html: item.comment }}/>  */}
                                            <div className="text" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: item.comment}}/>
                                        </div>
                                    </div>
                                ) : item.style && !item.comment && !item.secondValue && !item.componentRef ? (                              
                              
                                    <div style={{ background: "#a2ee7d", color: "#4B0307", textAlign: "left", padding: "0px 25px", border: "1px solid rgb(239, 239, 239)", width: "100%",paddingBottom:"20px" }}>                                
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>                                   
                                            <p className="text"> {item.label}:  </p>
                                        </div>                            
                                        {/*<p className="text" style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: item.newValue || item.value }}/>                                       */}
                                        <div className="text" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            {item.componentRef ? ( //PER FRECCIA PER SECONDA PAGINA - SCEHDA ENTE, INIZIATIVA , ETC.                             
                                <div style={{ paddingRight: "25px", color: "#879497", display: "flex", cursor:"pointer" }}
                                    onClick={() => goFinalInfo(item.componentRef)} >
                                    <KeyboardArrowRightIcon sx={{ color: '#879497' }} fontSize="large"/>
                                </div>
                            ) : ( <></>)}
                            
                        </div>
                    
                    ))}
       
                    <div style={{     
                        position:"relative",      
                        margin: "0px",                                                       
                        backgroundColor :"white",
                        display: "flex",
                        textAlign: "left",                                                                                        
                        paddingLeft:"70px",                        
                        gap: "20px"}}>
                           <div style={{ position: "absolute", top: "25%", left: 4, display: "flex", gap:1 }} >                            

                            {localStorage.getItem("ruolo")!="5" && praticaBloccata!=true ? (                              
                                    <IconButton size="small" onClick={() => handleOpenAllegati()}>
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                ): localStorage.getItem("ruolo")=="5" ? (
                                    <IconButton size="small" onClick={() => handleOpenAllegati()}>
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                ):(<></>)}
                            </div>

                            <p className="text importantText"  style={{ paddingLeft: "25px", color: "#30720f"}}>
                                Allegati:
                            </p>
                            {/*<>
                                <button  onClick={(event) => passing2(event)} style={{ marginLeft: "10px", width:'250px', marginTop:"10px",marginBottom:"10px",
                                borderTopLeftRadius: "15px", borderTopRightRadius: "15px",
                                borderBottomLeftRadius: "15px", borderBottomRightRadius: "15px",
                                borderColor:"#30720f",  fontSize:"15px",                                      
                                backgroundColor :"white", color:"#30720f"}}>Carica Nuovo Allegato</button>
                                <input id="fileupload00" type="file" name="file" ref={hiddenFileUpload2}
                                onChange={onFileChange2} style={{ display: "none" }} /> 
                    </> */}
                    </div>
                                        
                     <div style={{ flex: 1, marginBottom: '16px',   position:"relative",      
                        margin: "0px",                                                       
                        backgroundColor :"white",
                        display: "flex",
                        textAlign: "left",                                                                                        
                        paddingLeft:"95px",                        
                        //paddingRight:"25px",                        
                        gap: "20px" }}>
                        <table style={{borderCollapse: "collapse", width: "100%", marginRight:"10px",marginBottom:"10px" }}>
                        <thead>
                            <tr>
                                <th key="1.col" style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", fontSize:"14px" }}>
                                {"Sezione"}
                                </th>              
                                <th key="2.col" style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", fontSize:"14px" }}>
                                {"Nome file"}
                                </th>
                                <th key="3.col" style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", fontSize:"14px" }}>
                                {"Dimensione"}
                                </th>
                                <th key="4.col" style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", fontSize:"14px" }}>
                                {"Data caricamento"}
                                </th>
                            </tr>
                        </thead>

                        <tbody>         
                            { attachmentsAvailable(homeData) ?(
                            homeData.length > 0 && homeData.filter(item => item.tipo == "allegato")
                                .map((row, rowIndex) => (                                   
                                    
                                <tr key={rowIndex}>                                
                                    <td key={row['key']+"1"} style={{border: "1px solid #ccc", padding: 8 }}>                                              
                                        {row["sezione"]}                                              
                                    </td>
                                    <td key={row['key']+"2"} onClick={() => handleTdClick(row)} style={{border: "1px solid #ccc", padding: 8, cursor: "pointer" }}>                                              
                                        {row["label"]}                                              
                                    </td>
                                    <td key={row['key']+"3"} style={{border: "1px solid #ccc", padding: 8 }}>                                              
                                        {row["dimensione"]}                                              
                                    </td>
                                    <td key={row['key']+"4"} style={{border: "1px solid #ccc", padding: 8 }}>                                              
                                        {row["data_modifica"]}                                              
                                    </td>
                                </tr> 
                            ))
                        ):(
                            <tr>
                            <td colSpan={4} style={{ textAlign: 'center', color: '#888' }}>
                              Nessun allegato caricato
                            </td>
                          </tr> 
                        
                        )}
                        </tbody>
                        </table>
                </div>

            </div>
        {praticaUltimaModifica != '' || praticaModificataDa !='' ?(
            <p>
            Ultima modifica sulla pratica effettuata il:<strong> {praticaUltimaModifica} </strong>, dall'utente: <strong> {praticaModificataDa} </strong> 
            </p>          
        ):(<></>)}
        </div>
    )}

     <Modal
        open={open}
        keepMounted={false} 
        onClose={handleClose}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
        disableEnforceFocus
      >
        <div style={{ position: 'absolute', top: '5%', left: '5%', width: '90%', height: '90%',
            backgroundColor: 'white', padding: '20px', overflow: 'auto', boxShadow: 24,
            borderRadius: '8px', display: 'flex',flexDirection: 'column',}} >

            <h2 id="edit-modal-title">Modifica {openedLabel}</h2>
            <div style={{ flex: 1, marginBottom: '16px' }}>           
            
                <Editor   value={editorContent}                       
                       onEditorChange={handleEditorChange}
                       init={{ base_url: '/tinymce',
                            suffix: '.min',        
                            license_key: 'gpl',
                            promotion: false,
                            height: 250,
                            menubar: false,
                            statusbar:false,
                            branding: false,
                            plugins: [ 'lists','link'],                                                        
                            toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}/>
                                    
                        <Accordion sx={{ boxShadow: "none", backgroundColor: "transparent"}} >
                            <AccordionSummary >
                                <Typography fontSize={14} color="#777">
                                    Mostra valore originale
                                </Typography>
                            </AccordionSummary>

                            <AccordionDetails>
                                <div className="text" style={{ whiteSpace: 'normal',color:"#aaa", fontStyle: "italic",paddingTop:"10px" }}
                                            dangerouslySetInnerHTML={{ __html: itemContent.value}}/>   
                            </AccordionDetails>
                        </Accordion>                
                                 
                
            </div>
            <h2 id="edit-modal-title">Commento</h2>
            <div style={{ flex: 1, marginBottom: '16px' }}>            
                <Editor   value={commentContent}
                       onEditorChange={handleEditorCommentChange}
                       init={{ base_url: '/tinymce',
                            suffix: '.min',        
                            license_key: 'gpl',
                            promotion: false,
                            height: 250,
                            menubar: false,
                            statusbar:false,
                            branding: false,
                            plugins: [ 'lists','link'],
                            toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}/>
            </div>

            <div style={{ paddingTop:"10px", textAlign: 'right' }}>
                <button className="button154" onClick={handleClose} style={{ marginRight: 10, width:'100px' }}>Annulla</button>
                <button className="button11" onClick={handleSave} style={{ marginRight: 10, width:'100px' }}>Salva</button>
            </div>
        </div>
      </Modal>

      <Modal
        open={openII}
        keepMounted={false} 
        onClose={handleCloseII}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
        disableEnforceFocus
      >
        <div
          style={{
            position: 'absolute',
            top: '5%',
            left: '5%',
            width: '90%',
            height: '90%',
            backgroundColor: 'white',
            padding: '20px',
            overflow: 'auto',
            boxShadow: 24,
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h2 id="edit-modal-title">Modifica IPOTESI INTERVENTO</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
            {/*<ReactQuill
              value={normalizeQuill(editorIpotesi)}
              onChange={setEditorIpotesi}
              style={{ height: '80%' 
              }}
              modules={{
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['link', 'image'],
                    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                  ],                 
              }}
            /> */}
             <Editor   value={editorIpotesi}
                       onEditorChange={handleEditorIpotesiChange}
                       init={{ base_url: '/tinymce',
                            suffix: '.min',        
                            license_key: 'gpl',
                            promotion: false,
                            height: 250,
                            menubar: false,
                            branding: false,
                            statusbar:false,
                            plugins: [ 'lists','link'],
                            toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}/>


          </div>
          <h2 id="edit-modal-title">Modifica RUOLO DELLA COMPAGNIA</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
          {/*}  <ReactQuill
              value={normalizeQuill(editorRuolo)}
              onChange={setEditorRuolo}
              style={{ height: '80%' 
              }}
              modules={{
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['link', 'image'],
                    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                  ],             
              }}
            />
            */}
             <Editor   value={editorRuolo}
                       onEditorChange={handleEditorRuoloChange}
                       init={{ base_url: '/tinymce',
                            suffix: '.min',        
                            license_key: 'gpl',
                            promotion: false,
                            height: 250,
                            menubar: false,
                            statusbar:false,
                            branding: false,
                            plugins: [ 'lists','link'],
                            toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}/>
          </div>        
          <h2 id="edit-modal-title">Commento</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
           {/*} <ReactQuill
              value={normalizeQuill(commentContent)}
              onChange={setCommentContent}
              style={{ height: '80%' 
              }}
              modules={{
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['link', 'image'],
                    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                  ],                  
              }}
            /> */}
               <Editor   value={commentContent}
                       onEditorChange={handleEditorCommentChange}
                       init={{ base_url: '/tinymce',
                            suffix: '.min',        
                            license_key: 'gpl',
                            promotion: false,
                            height: 250,
                            menubar: false,
                            statusbar:false,
                            branding: false,
                            plugins: [ 'lists','link'],
                            toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}/>
          </div> 
          <div style={{ paddingTop:"10px", textAlign: 'right' }}>
            <button className="button154" onClick={handleCloseII} style={{ marginRight: 10, width:'100px' }}>Annulla</button>
            <button className="button11" onClick={handleSaveII} style={{ marginRight: 10, width:'100px' }}>Salva</button>
          </div>
        </div>
      </Modal>

      <Modal
        open={openER}
        keepMounted={false} 
        onClose={handleCloseER}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
        disableEnforceFocus
      >
        <div
          style={{
            position: 'absolute',
            top: '5%',
            left: '5%',
            width: '90%',
            height: '90%',
            backgroundColor: 'white',
            padding: '20px',
            overflow: 'auto',
            boxShadow: 24,
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h2 id="edit-modal-title">Modifica EXECUTIVE SUMMARY</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
          
          <Editor   value={editorExecutive}
            onEditorChange={handleEditorExecutiveChange}
            init={{ base_url: '/tinymce',
                suffix: '.min',        
                license_key: 'gpl',
                promotion: false,
                height: 250,
                menubar: false,
                branding: false,
                statusbar:false,
                plugins: [ 'lists','link'],
                toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
            }}/>
          </div>
          <h2 id="edit-modal-title">Modifica RELAZIONE/ANNOTAZIONI</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
         
          <Editor   value={editorRelazione}
            onEditorChange={handleEditorRelazioneChange}
            init={{ base_url: '/tinymce',
                suffix: '.min',        
                license_key: 'gpl',
                promotion: false,
                height: 250,
                menubar: false,
                statusbar:false,
                branding: false,
                plugins: [ 'lists','link'],
                toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
            }}/>
          </div>        
          <h2 id="edit-modal-title">Commento</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
        
          <Editor   value={commentContent}
            onEditorChange={handleEditorCommentChange}
            init={{ base_url: '/tinymce',
                suffix: '.min',        
                license_key: 'gpl',
                promotion: false,
                height: 250,
                menubar: false,
                statusbar:false,
                branding: false,
                plugins: [ 'lists','link'],
                toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
            }}/>
          </div> 
          <div style={{ paddingTop:"10px", textAlign: 'right' }}>
            <button className="button154" onClick={handleCloseER} style={{ marginRight: 10, width:'100px' }}>Annulla</button>
            <button className="button11" onClick={handleSaveER} style={{ marginRight: 10, width:'100px' }}>Salva</button>
          </div>
        </div>
      </Modal>


      <Modal
        open={openDettaglioBudget}
        onClose={handleCloseDettaglioBudget}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
      >
        <div
          style={{
            position: 'absolute',
            top: '5%',
            left: '5%',
            width: '90%',
            height: '90%',
            backgroundColor: 'white',
            padding: '20px',
            overflow: 'auto',
            boxShadow: 24,
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h2 id="edit-modal-title">Modifica allocazione Importo Proposto</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
          <table style={{borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr>
                {visibleDettaglioCols.map((colIndex) => (
                <th key={colIndex} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1"  }}>
                  {tableContent[0]?.[colIndex]}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
          <tr key={"tot00"} style={{color:"grey"}}>                                                        
                    <td key={"tot00-1"} style={{border: "1px solid #ccc", padding: 8 }}>
                    {"Importo Proposto"}
                    </td>   
                    <td key={"tot00-2"} style={{border: "1px solid #ccc", padding: 8 }}>            
                    {parseFloat(editorAnnoInCorso).toFixed(2).replace('.', ',')}
                    </td>   
                    <td key={"tot00-3"} style={{border: "1px solid #ccc", padding: 8 }}>                                
                    {parseFloat(editorAnnoPrecedente).toFixed(2).replace('.', ',')}
                    </td>                                                             
          </tr>  
          <tr key={"tot01"} style={{color:"grey"}}>                                                        
                    <td key={"tot01-1"} style={{border: "1px solid #ccc", padding: 8 }}>
                    {"Importo Proposto già suddiviso"}
                    </td>   
                    <td key={"tot01-2"} style={{border: "1px solid #ccc", padding: 8, 
                     /*color: tableContent.slice(2).reduce((acc, row) =>
                           acc + (parseFloat(row[4].replace(/\./g, "").replace(",", ".")) || 0),0
                ) != parseFloat(editorAnnoInCorso).toFixed(2).replace('.', ',') ? "#f00" : "#ccc" */
                color: tableContent.slice(2).reduce((acc, row) =>
                    acc + (parseFloat(row[4].replace(/\./g, "").replace(",", ".")) || 0),0) !== parseFloat(editorAnnoInCorso) ? "#f00": "grey"}}>
                    {tableContent.slice(2).reduce((acc, row) =>
                        acc + (parseFloat(row[4].replace(/\./g, "").replace(",", ".")) || 0),0).toFixed(2)
                        .replace(".", ",")}                       
                    </td>   
                    <td key={"tot01-3"} style={{border: "1px solid #ccc", padding: 8, 
                     /*color: tableContent.slice(2).reduce((acc, row) =>
                           acc + (parseFloat(row[5].replace(/\./g, "").replace(",", ".")) || 0),0
                    ) != parseFloat(editorAnnoPrecedente).toFixed(2).replace('.', ',') ? "#f00" : "#ccc" */
                    color: tableContent.slice(2).reduce((acc, row) =>
                    acc + (parseFloat(row[5].replace(/\./g, "").replace(",", ".")) || 0),0) !== parseFloat(editorAnnoPrecedente) ? "#f00": "grey"}}>
                    {tableContent.slice(2).reduce((acc, row) =>
                        acc + (parseFloat(row[5].replace(/\./g, "").replace(",", ".")) || 0),0).toFixed(2)
                        .replace(".", ",")}                       
                    </td>   
              </tr>  
            {tableContent.slice(2).map((row, rowIndex) => (
              
              <tr key={rowIndex}  style={{ 
                backgroundColor: rowIndex % 2 === 0 ? "#ffffff" : "#f7f7f7" 
              }}>
            
                  {visibleDettaglioCols.map((colIndex) => (
                  
                  <td key={colIndex} //style={{border: "1px solid #ccc", padding: 8 }}
                  style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "transparent" }}>
                  
                    {(colIndex === 4 || colIndex === 5) ? (
                      <input
                        type="text"
                        value={row[colIndex]}
                        onFocus={(e) => { 
                            e.target.parentElement.style.backgroundColor = "#f5f7fa"; 
                            e.target.parentElement.style.boxShadow = "inset 0 0 0 1px #1976d2";
                        }}
                        onBlur={(e) => { 
                            e.target.parentElement.style.backgroundColor = "#fff";
                            e.target.parentElement.style.boxShadow = "none";
                        }}    
                        onChange={(e) =>
                            //handleChangeInTable(rowIndex + 1, colIndex, e.target.value)
                            handleChangeInTable(rowIndex+2, colIndex, e.target.value)
                        }
                        style={{width: "100%", border: "none",outline: "none", background: "transparent", fontSize: "16px", padding: "2px 0", cursor: "text"}}
                      />
                    ) : (
                      row[colIndex]
                    )}
                  </td>
                ))}   
              </tr>
              
            ))}
          </tbody>
        </table>
          </div>
         
        
          <div style={{ paddingTop:"10px", textAlign: 'right' }}>
            <button className="button154" onClick={handleCloseDettaglioBudget} style={{ marginRight: 10, width:'100px' }}>Annulla</button>
            <button className="button11" onClick={handleSaveDettaglioBudget} style={{ marginRight: 10, width:'100px' }}>Salva</button>
          </div>
        </div>
      </Modal>
    
    
      <Modal
        open={openAllegati}
        onClose={handleCloseAllegati}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
      >
        <div
          style={{
            position: 'absolute',
            top: '5%',
            left: '5%',
            width: '90%',
            height: '90%',
            backgroundColor: 'white',
            padding: '20px',
            overflow: 'auto',
            boxShadow: 24,
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h2 id="edit-modal-title">Modifica Allegati</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
          <table style={{borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr>    
                <th key={"head"+0} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", width:"5%"  }}>
                  {""}
                </th>                     
                <th key={"head"+1} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", width:"28%"  }}>
                  {"Riferimento file"}
                </th>
                <th key={"head"+2} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1",width:"37%"  }}>
                  {"Nome file mostrato"}
                </th>
                <th key={"head"+3} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1",width:"20%"  }}>
                  {"Sezione"}
                </th>
                <th key={"head"+4} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1",width:"10%"  }}>
                  {"Posizione"}
                </th>
            </tr>
          </thead>

          <tbody>
            {tableAllegati.length > 0 ? (  
                //console.log(">0",tableAllegati,tableAllegati.length),              
                tableAllegati.map((row, rowIndex) => (              
                <tr key={rowIndex}>                                                           
                            <td key={row.key + "_q0"}
                                style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "#fff"}}>
                                <IconButton size="small" onClick={() => handleDeleteRow(row.key)}>
                                    <DeleteIcon fontSize="small" style={{color:"#bf360c"}}/>
                                </IconButton>
                                
                            </td>
                            <td key={row.key + "_q1"} onClick={() => handleTdClick(row)}
                                style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "#fff", cursor: "pointer"}}>
                                <p style={{fontSize: "14px", padding: "2px 0", color:"rgb(84, 84, 84)" }} >{row["value"]} </p>
                                {/*
                                <input type="text" value={row["value"]}   disabled                             
                                    style={{width: "100%", border: "none",outline: "none", background: "transparent", fontSize: "14px", padding: "2px 0", cursor: "pointer"}}
                                    
                                    />
                                */}
                            </td>
                            <td key={row.key + "_q2"}
                                style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "#fff"}}>
                                
                                <input type="text" value={row["label"]}                                
                                    style={{width: "100%", border: "none",outline: "none", background: "transparent", fontSize: "14px", padding: "2px 0", cursor: "text"}}
                                    onChange={(e) => handleChangeInAllegatiTable(rowIndex, "label", e.target.value)}
                                    onFocus={(e) => { 
                                        e.target.parentElement.style.backgroundColor = "#f5f7fa"; 
                                        e.target.parentElement.style.boxShadow = "inset 0 0 0 1px #1976d2";
                                    }}
                                    onBlur={(e) => { 
                                        e.target.parentElement.style.backgroundColor = "#fff";
                                        e.target.parentElement.style.boxShadow = "none";
                                    }}/>
                            </td>

                            <td key={row.key+"_q3"} 
                                style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "#fff"}}>
                                <select value={row["sezione"]}
                                    onChange={(e) =>
                                        handleChangeInAllegatiTable(rowIndex, "sezione", e.target.value)
                                    }
                                    style={{ width: "100%", border: "none", outline: "none", background: "transparent", fontSize: "14px",
                                        padding: "2px 0", cursor: "pointer", appearance: "none", WebkitAppearance: "none", MozAppearance: "none" }}
                                    onFocus={(e) => {
                                        e.target.parentElement.style.backgroundColor = "#f5f7fa";
                                        e.target.parentElement.style.boxShadow = "inset 0 0 0 1px #1976d2";
                                    }}
                                    onBlur={(e) => {
                                        e.target.parentElement.style.backgroundColor = "#fff";
                                        e.target.parentElement.style.boxShadow = "none";
                                    }}>
                                        <option value="SCHEDA INIZIATIVA">SCHEDA INIZIATIVA</option>
                                        <option value="SCHEDA ENTE">SCHEDA ENTE</option>
                                        <option value="EXECUTIVE SUMMARY">EXECUTIVE SUMMARY</option>
                                        <option value="RELAZIONE ANNOTAZIONI">RELAZIONE ANNOTAZIONI</option>
                                        
                                </select>
                                {/** 
                                <span
                                        style={{ position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)",
                                            pointerEvents: "none", fontSize: "10px", color: "#666"}}> ▼
                                </span>
                                */}        
                                
                            </td>                
                            <td key={row.key + "_q4"}
                                style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "#fff"}}>
                                {/** 
                                <input type="text" value={row["posizione"]}                                
                                    style={{width: "100%", border: "none",outline: "none", background: "transparent", fontSize: "14px", padding: "2px 0", cursor: "text"}}
                                    onChange={(e) => handleChangeInAllegatiTable(rowIndex, "posizione", e.target.value)}
                                    onFocus={(e) => { 
                                        e.target.parentElement.style.backgroundColor = "#f5f7fa"; 
                                        e.target.parentElement.style.boxShadow = "inset 0 0 0 1px #1976d2";
                                    }}
                                    onBlur={(e) => { 
                                        e.target.parentElement.style.backgroundColor = "#fff";
                                        e.target.parentElement.style.boxShadow = "none";
                                    }}/>
                                */}
                                <select value={row["posizione"]}
                                    onChange={(e) =>
                                        handleChangeInAllegatiTable(rowIndex, "posizione", e.target.value)
                                    }
                                    style={{ width: "100%", border: "none", outline: "none", background: "transparent", fontSize: "14px",
                                        padding: "2px 0", cursor: "pointer", appearance: "none", WebkitAppearance: "none", MozAppearance: "none" }}
                                    onFocus={(e) => {
                                        e.target.parentElement.style.backgroundColor = "#f5f7fa";
                                        e.target.parentElement.style.boxShadow = "inset 0 0 0 1px #1976d2";
                                    }}
                                    onBlur={(e) => {
                                        e.target.parentElement.style.backgroundColor = "#fff";
                                        e.target.parentElement.style.boxShadow = "none";
                                    }}>
                                        <option value="0">0</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                        <option value="13">13</option>
                                        <option value="14">14</option>
                                        <option value="15">15</option>
                                        <option value="16">16</option>
                                        <option value="17">17</option>
                                        <option value="18">18</option>
                                        <option value="19">19</option>
                                        <option value="20">20</option>                                    
                                </select>
                            </td>
                </tr>                                
                ))): (
                    //console.log("==0",tableAllegati,tableAllegati.length),              
                        <tr>
                        <td colSpan={5} style={{ textAlign: 'center', color: '#888' }}>
                          Nessun allegato presente
                        </td>
                      </tr>   
                    )
            }
          </tbody>
        </table>
          </div>
         
        
          <div style={{ paddingTop:"10px", textAlign: 'right' }}>
            <button className="button154" onClick={handleCloseAllegati} style={{ marginRight: 10, width:'100px' }}>Annulla</button>
            <button className="button11" onClick={handleSaveAllegati} style={{ marginRight: 10, width:'100px' }}>Salva</button>
          </div>
        </div>
      </Modal>


      <Modal
        open={openImporto}
        onClose={handleCloseImportoProposto}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
      >
        <div
          style={{
            position: 'absolute',
            top: '5%',
            left: '5%',
            width: '90%',
            height: '90%',
            backgroundColor: 'white',
            padding: '20px',
            overflow: 'auto',
            boxShadow: 24,
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h2 id="edit-modal-title">Modifica Suddivisione Importo Proposto</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
          <table style={{borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr>                   
                <th key={"head"+1} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", width:"30%"  }}>
                  {"Importo Proposto"}
                </th>
                <th key={"head"+2} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1",width:"33%"  }}>
                  {"Importo Anno In Corso"}
                </th>
                <th key={"head"+3} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1",width:"33%"  }}>
                  {"Importo Anno Precedente"}
                </th>                
            </tr>
          </thead>

          <tbody>                
              <tr key={"001"}>                                                                                  
                        <td key={"001_q1"}
                            style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "#fff"}}>
                            
                            <input type="text" 
                            //value={parseFloat(homeData.find(item => item.label === "Importo Proposto")?.value).toFixed(2).replace(".", ",")}
                            value={(() => {
                                const raw = homeData.find(
                                  item => item.label === "Importo Proposto"
                                )?.value;
                            
                                if (raw == null || raw === "") return "";
                            
                                let v = raw;
                            
                                if (typeof v === "string" && v.includes(",")) {
                                  v = v.replaceAll(".", "").replace(",", ".");
                                }
                            
                                const n = Number(v);
                            
                                if (isNaN(n)) return "";
                            
                                return n.toFixed(2).replace(".", ",");
                              })()}
                               disabled                                                         
                                style={{width: "100%", border: "none",outline: "none", background: "transparent", fontSize: "16px", padding: "2px 0", cursor: "text"}}                                
                                />
                        </td>
                        <td key={"001_q2"}
                            style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "#fff"}}>
                            {/*
                            <input type="text"                             
                            //value={editorAnnoInCorso.replace(".", ",")}   
                            value={(() => {
                                const raw = editorAnnoInCorso;
                            
                                if (raw == null || raw === "") return "";
                            
                                let v = raw;
                            
                                if (typeof v === "string" && v.includes(",")) {
                                  v = v.replaceAll(".", "").replace(",", ".");
                                }
                            
                                const n = Number(v);
                            
                                if (isNaN(n)) return "";
                            
                                return n.toFixed(2).replace(".", ",");
                              })()}
                                inputMode="decimal"                            
                                style={{width: "100%", border: "none",outline: "none", background: "transparent", fontSize: "16px", padding: "2px 0", cursor: "text",                                
                                  color: toNumberIT(editorAnnoInCorso) +
                                  toNumberIT(editorAnnoPrecedente) !==
                                  toNumberIT(homeData.find(item => item.label === "Importo Proposto")?.value)
                              ? "red"
                              : "black"  
                            }}
                                onChange={(e) => handleChangeImportoProposto("Importo Anno In Corso", e.target.value)}
                                                                
                                onFocus={(e) => { 
                                    e.target.parentElement.style.backgroundColor = "#f5f7fa"; 
                                    e.target.parentElement.style.boxShadow = "inset 0 0 0 1px #1976d2";
                                }}
                                onBlur={(e) => { 
                                    e.target.parentElement.style.backgroundColor = "#fff";
                                    e.target.parentElement.style.boxShadow = "none";
                                    handleChangeImportoProposto("Importo Anno In Corso", sanitizeImporto(e.target.value))
                                }}
                                />*/}
                                <input
                                    type="text"
                                    value={editorAnnoInCorso ?? ""}
                                    inputMode="decimal"
                                    style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        background: "transparent",
                                        fontSize: "16px",
                                        padding: "2px 0",
                                        cursor: "text",
                                        color:
                                        toNumberIT(editorAnnoInCorso) +
                                            toNumberIT(editorAnnoPrecedente) !==
                                        toNumberIT(
                                            homeData.find(item => item.label === "Importo Proposto")?.value
                                        )
                                            ? "red"
                                            : "black"
                                    }}
                                    onChange={(e) =>
                                        handleChangeImportoProposto(
                                          "Importo Anno In Corso",
                                          e.target.value
                                        )
                                      }  
                                      onBlur={(e) => {
                                        e.target.parentElement.style.backgroundColor = "#fff";
                                        e.target.parentElement.style.boxShadow = "none";
                                      
                                        const formatted = sanitizeImporto(e.target.value);
                                        handleChangeImportoProposto("Importo Anno In Corso", formatted);
                                      }}
                                />
                        </td>
                        <td key={"001_q3"}
                            style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "#fff"}}>
                            {/*}
                            <input type="text" //value={editorAnnoPrecedente.replace(".", ",")}     
                              value={(() => {
                                const raw = editorAnnoPrecedente;
                            
                                if (raw == null || raw === "") return "";
                            
                                let v = raw;
                            
                                if (typeof v === "string" && v.includes(",")) {
                                  v = v.replaceAll(".", "").replace(",", ".");
                                }
                            
                                const n = Number(v);
                            
                                if (isNaN(n)) return "";
                            
                                return n.toFixed(2).replace(".", ",");
                              })()}
                                inputMode="decimal"                           
                                style={{width: "100%", border: "none",outline: "none", background: "transparent", fontSize: "16px", padding: "2px 0", cursor: "text",                             
                                  color: toNumberIT(editorAnnoInCorso) +
                                        toNumberIT(editorAnnoPrecedente) !==
                                        toNumberIT(homeData.find(item => item.label === "Importo Proposto")?.value)
                                    ? "red"
                                    : "black"  
                                }}
                                
                                onChange={(e) => {                                
                                      handleChangeImportoProposto("Importo Anno Precedente", e.target.value);
                                  }}
                                onFocus={(e) => { 
                                    e.target.parentElement.style.backgroundColor = "#f5f7fa"; 
                                    e.target.parentElement.style.boxShadow = "inset 0 0 0 1px #1976d2";
                                }}
                                onBlur={(e) => { 
                                    e.target.parentElement.style.backgroundColor = "#fff";
                                    e.target.parentElement.style.boxShadow = "none";
                                    handleChangeImportoProposto("Importo Anno Precedente", sanitizeImporto(e.target.value));
                                }}/>
                                */}
                                <input
                                    type="text"
                                    value={editorAnnoPrecedente ?? ""}
                                    inputMode="decimal"
                                    style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        background: "transparent",
                                        fontSize: "16px",
                                        padding: "2px 0",
                                        cursor: "text",
                                        color:
                                        toNumberIT(editorAnnoInCorso) +
                                            toNumberIT(editorAnnoPrecedente) !==
                                        toNumberIT(
                                            homeData.find(item => item.label === "Importo Proposto")?.value
                                        )
                                            ? "red"
                                            : "black"
                                    }}
                                    onChange={(e) =>
                                        handleChangeImportoProposto(
                                          "Importo Anno Precedente",
                                          e.target.value
                                        )
                                      }   
                                      onBlur={(e) => {
                                        e.target.parentElement.style.backgroundColor = "#fff";
                                        e.target.parentElement.style.boxShadow = "none";
                                      
                                        const formatted = sanitizeImporto(e.target.value);
                                        handleChangeImportoProposto("Importo Anno Precedente", formatted);
                                      }} />
                        </td>
                                     
                     
              </tr>
                          
          </tbody>
        </table>
          </div>
         
        
          <div style={{ paddingTop:"10px", textAlign: 'right' }}>
            <button className="button154" onClick={handleCloseImportoProposto} style={{ marginRight: 10, width:'100px' }}>Annulla</button>
            <button className="button11" onClick={handleSaveImportoProposto} style={{ marginRight: 10, width:'100px' }}>Salva</button>
          </div>
        </div>
      </Modal>
      {alert}
    </div>   
       
    );
}
